<script setup lang="ts">

const { isReversed = false } = defineProps<{ isReversed?: boolean}>();

</script>

<template>

    <div class="flex items-center flex-col md:flex-row"
         :class="{ 'md:!flex-row-reverse': isReversed }">

        <div class="basis-full md:basis-2/5 flex justify-center overflow-hidden
                    rounded-sm rounded-bl-[20vw] rounded-tr-[20vw] md:rounded-bl-[10vw] md:rounded-tr-[5vw]">
            <slot name="image"></slot>
        </div>

        <div class="basis-full md:basis-3/5 text-left pr-8 md:pr-16 pl-8"
             :class="{ '!pl-8 pr-8 md:pr-16': isReversed }">
            <h1 class="text-4xl font-semibold mt-6 mb-3">
                <slot name="headline"></slot>
            </h1>
            <slot></slot>
        </div>
    
    </div>

</template>